import script from "./OidoSlottedDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoSlottedDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./OidoSlottedDatePicker.vue?vue&type=style&index=0&id=6dafee96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dafee96"]])

export default __exports__